import axios from 'axios';
import { appEnv } from '../constants/appEnv';

class AdApi {
    static get(page) {
        return axios.get(digitalData.microServiceInfo.Gateway.uri + "/inkandtoner/ad").then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }
}
export default AdApi;  